// MokoBoko's own addresses report to MokoBoko's PostHog project; every other
// host, each studio's subdomain and custom domain alike, reports to the
// platform's. The split is by address rather than by tenant record because
// posthog.ts initialises at module scope, before the tenant has been fetched.
const MOKOBOKO_HOSTNAMES = ['mokoboko.xyz', 'www.mokoboko.xyz'];
const MOKOBOKO_SLUG = 'mokoboko';

// The same normalisation as hostnameOf in tenant-host.ts, repeated here because
// that module imports env, which throws at import time outside a build.
const toHostname = (host: string) =>
  host.toLowerCase().split(':')[0].replace(/\.$/, '');

export const isMokoBokoHost = (host: string, platformDomain: string) => {
  const hostname = toHostname(host);
  return (
    MOKOBOKO_HOSTNAMES.includes(hostname) ||
    hostname === `${MOKOBOKO_SLUG}.${toHostname(platformDomain)}`
  );
};

// Falls back to the platform key while the MokoBoko one is unset, so a deploy
// that lands ahead of the env change keeps reporting instead of going dark.
export const postHogKeyForHost = ({
  host,
  platformDomain,
  defaultKey,
  mokobokoKey,
}: {
  host: string;
  platformDomain: string;
  defaultKey: string | undefined;
  mokobokoKey: string | undefined;
}): string | undefined =>
  mokobokoKey && isMokoBokoHost(host, platformDomain)
    ? mokobokoKey
    : defaultKey;
